import { SystemType } from 'types/System';
import { client } from './axios';

const fetchConfig = (): Promise<SystemType> => client.get(`/api/systems/config`);

export default {
  fetchConfig,
};
